export const transformResponseOrderTrackingEmbed = embed => {
  return {
    allowed_domains: embed.allowed_domains,
    hide_header: embed.hide_header,
  }
}

export const transformRequestEditOrderTrackingEmbed = ({ storeId, embed }) => {
  return {
    storeId,
    embed: {
      allowed_domains: embed.allowed_domains,
      hide_header: embed.hide_header,
    },
  }
}
